import styled from 'styled-components';
import { Section } from '../../shared/TabStyles';

export const PromptsSection = styled(Section)`
  background-color: var(--lightest-blue);
  padding: 2rem;
  border-radius: 12px;
  margin: 3rem 0;
  
  h2 {
    border-bottom-color: rgba(0, 82, 204, 0.2);
  }
`;

export const PromptGuideContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin: 2rem 0;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const PromptGuideItem = styled.div`
  background-color: white;
  padding: 1.5rem 2rem 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }
  
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--primary-color);
    margin: 0 0 1.5rem;
    text-align: center;
  }
  
  ul {
    margin: 0;
    padding-left: 1.25rem;
    width: 100%;
    
    li {
      font-size: 1rem;
      line-height: 1.6;
      margin-bottom: 0.75rem;
      color: var(--text-color);
      word-break: break-word;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

export const PromptTipsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  margin: 2rem 0;
`;

export const PromptTip = styled.div`
  background-color: var(--lightest-blue);
  padding: 1.5rem;
  border-radius: 8px;
  
  h3 {
    margin-top: 0;
    color: var(--dark-blue);
  }
  
  p {
    margin-bottom: 0;
  }
`;

export const PromptExamplesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const PromptExample = styled.div`
  background-color: white;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  align-items: flex-start;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    z-index: 1;
  }
  
  p {
    margin: 0;
    font-style: italic;
    line-height: 1.6;
    color: var(--text-color);
    font-size: 0.95rem;
  }
`;

export const PitfallsList = styled.ul`
  padding-left: 1.5rem;
  margin-bottom: 1rem;
  
  li {
    margin-bottom: 0.5rem;
    line-height: 1.6;
  }
`;

// Animation variants for the component
export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.4 }
  }
};

export const promptItemVariants = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { 
    opacity: 1, 
    scale: 1,
    transition: { type: "spring", stiffness: 100 }
  },
  hover: { 
    y: -5,
    boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
    transition: { duration: 0.2 }
  }
};

export const ProjectSection = styled(Section)`
  margin: 2rem 0;
`;

export const ProjectContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;
  margin-top: 1.5rem;

  > div:last-child {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  h3 {
    color: var(--primary-color);
    margin: 1.5rem 0 1rem;
    font-size: 1.2rem;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.6;
    color: ${props => props.theme.text};
    margin: 1rem 0;

    strong {
      display: inline-block;
      margin-bottom: 0.25rem;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    
    img {
      order: -1;
    }
  }
`;

export const ProjectImage = styled.img`
  width: 90%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: block;
  margin: 0 auto;
`;

export const IdealPromptSection = styled.div`
  margin: 2rem 0;
  padding: 2rem;
  background-color: var(--lightest-blue);
  border-radius: 12px;
  
  h3 {
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--primary-color);
    margin: 0 0 0.5rem;
  }
  
  p {
    margin-bottom: 2rem;
    color: var(--text-color);
  }
`;

export const PromptingTipsSection = styled.div`
  margin: 2rem 0;
  padding: 2rem;
  background-color: var(--light-green);
  border-radius: 12px;
  
  h3 {
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--primary-color);
    margin: 0 0 0.5rem;
  }
  
  p {
    margin-bottom: 2rem;
    color: var(--text-color);
  }
`; 